<template>
  <div>
    <div class="is-flex is-align-items-center is-justify-content-space-between">
      <label class="label">Addresses</label>
      <button v-show="addresses.length < 3"
        class="button is-small is-primary is-light"
        :class="`is-light-btn-${$theme.name}`"
        @click="addTmpAddress">
        <span class="icon">
          <span class="mso mso-24px">
            add
          </span>
        </span>
      </button>
    </div>
    <div v-for="(address, index) in addresses"
      :key="index"
      class="pb-4">
      <div class="field has-addons">
        <p class="control">
          <span class="select">
            <select v-model="address.type"
              :class="{ 'is-invalid' : $v.uniqueAddressType !== undefined && !$v.uniqueAddressType }"
              v-tippy="{ content: 'Duplicate Type', theme: 'danger', enabled: $v.uniqueAddressType !== undefined && !$v.uniqueAddressType }">
              <option v-for="(type, typeIndex) in addressTypes"
                :key="typeIndex"
                :value="typeIndex">
                {{ type }}
              </option>
            </select>
          </span>
        </p>
        <p class="control is-expanded">
          <google-autocomplete v-if="googleApi.mapStatus"
            :bounds="googleApi.bounds"
            :id="'address' + index"
            :address="address"
            :v="$v.addresses.$each[index]"
            :show-address3="true"
            :country-code="googleMapAutoCompleteCountryCode" />
        </p>
        <p class="control">
          <button class="button has-text-gold"
            @click="setDefault(address)">
            <span class="icon">
              <span class="mso mso-24px"
                :class="[address.isDefault ? 'mso-fill': '']">
                star
              </span>
            </span>
          </button>
        </p>
        <p class="control">
          <button class="button has-text-danger"
            @click="removeAddress(address)">
            <span class="icon">
              <span class="mso mso-24px">
                delete
              </span>
            </span>
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAutocomplete from '@/components/Address/GoogleAutocomplete'
import { AddressTypes } from '@/enums'
// import UserValidation from '../UserValidation.js'
import addresses from '@/assets/validateForms/Address'
export default {
  name: 'UserAssetAddresses',
  components: {
    GoogleAutocomplete
  },
  props: {
    addresses: {
      type: Array,
      default: () => []
    },
    countryCode: {
      type: String | null,
      default: undefined
    },
    required: { type: Boolean, default: false },
    assetTypeName: {
      type: String | null,
      default: 'assetAddresses'
    }
  },

  data() {
    return {
      googleApi: {
        mapUrl: 'https://maps.googleapis.com/maps/api/js',
        mapKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        mapLibraries: 'places',
        mapCallback: 'initMap',
        mapStatus: null,
        bounds: null
      }
    }
  },

  computed: {
    addressTypes() {
      return AddressTypes
    },
    existedAddressTypes() {
      return this.addresses.map((address) => address.type)
    },
    googleMapAutoCompleteCountryCode() {
      if (this.countryCode) {
        return this.countryCode
      }
      return this.$company.info.countryCode
    }
  },

  watch: {
    addresses: {
      handler() {
        this.$emit('validationChanged', this.hasAnyValidationError())
      },
      deep: true
    }
  },
  mounted() {
    this.$v.$touch()
  },

  created() {
    this.initGoogleMapApi()
  },

  methods: {
    addTmpAddress() {
      this.$emit('addTmpAddress')
    },
    initGoogleMapApi() {
      const vm = this
      window.initMap = function () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            const geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            const circle = new window.google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            })

            vm.googleApi.bounds = circle.getBounds()
          })
        }
        vm.googleApi.mapStatus = 'AddressDetail'
      }

      if (!window.google) {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = `${this.googleApi.mapUrl}?key=${this.googleApi.mapKey}&libraries=${this.googleApi.mapLibraries}&callback=${this.googleApi.mapCallback}`
        document.body.appendChild(script)
      } else {
        window.initMap()
      }
    },
    removeAddress(assetAddress) {
      this.$emit('removeAddress', assetAddress)
    },
    setDefault(assetAddress) {
      this.$emit('setDefault', assetAddress, this.assetTypeName)
    },
    hasAnyValidationError() {
      return this.$v.$error || !this.$v.uniqueAddressType || this.$v.addresses.$error
    }
  },

  validations() {
    // const baseValidations = UserValidation.validations.entity || {}
    // const addressValidations = this.required
    //   ? {
    //       ...addresses
    //     }
    //   : {
    //       ...baseValidations
    //     }

    return {
      ...addresses,
      uniqueAddressType: () => new Set(this.existedAddressTypes).size == this.existedAddressTypes.length
    }
  }
}
</script>